import { render, staticRenderFns } from "./YouTubeManager.vue?vue&type=template&id=6e8bce2a&"
import script from "./YouTubeManager.vue?vue&type=script&lang=js&"
export * from "./YouTubeManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports